<template>
  <SelectItem
    :value="value"
    class="tw-w-full tw-px-3 tw-py-2 hover:tw-bg-secondary-50 tw-cursor-pointer tw-outline-none"
  >
    <SelectItemText>
      <slot />
    </SelectItemText>
  </SelectItem>
</template>

<script setup lang="ts">
import { SelectItem, SelectItemText } from "reka-ui";
import { inject, onMounted } from "vue";

const props = defineProps<{
  value: string;
  textValue: string;
}>();

const registerItemText =
  inject<(value: string, text: string) => void>("registerItemText");

onMounted(() => {
  registerItemText?.(props.value, props.textValue);
});
</script>
